var render = function render(){var _vm=this,_c=_vm._self._c;return _c('yandex-map',{attrs:{"coords":_vm.$props.coordinates,"zoom":_vm.$props.zoom,"controls":_vm.setControls,"options":{ suppressMapOpenBlock: true }}},[_c('ymap-marker',{attrs:{"coords":_vm.$props.coordinates,"marker-id":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }